import React, { useEffect, useState } from 'react'
import CustomModal from '../../../../../components/CustomModal/CustomModal'
import CustomDropdown from '../../../../../components/CustomDropdown/CustomDropdown'
import Btn from '../../../../../components/Btn/Btn'
import { InputMoeda } from '../../../../../components'

export default function DiariasPorVeiculoModal({
  show,
  data, // se vier id => edição
  tiposVeiculos,
  diarias,
  onSave,
  onClose,
}) {
  const NEW = { id: undefined, manufacturer_id: null, day: 1, value: null }
  const [form, setForm] = useState(NEW)

  useEffect(() => {
    if (data) {
      setForm({ ...data })
    } else if (show) {
      setForm(NEW)
    }
  }, [data, show])

  /* calcula próximo dia somente quando for NOVO cadastro */
  const onTipoVeiculoChange = tipo => {
    const maxDay = diarias
      .filter(d => d.manufacturer_id === tipo.id)
      .reduce((max, d) => (d.day > max ? d.day : max), 0)
    setForm({ ...form, manufacturer_id: tipo.id, day: maxDay + 1 || 1 })
  }

  const emEdicao = !!form.id

  return (
    <CustomModal
      header={emEdicao ? 'Editar diária' : 'Nova diária'}
      isVisible={show}
      onClose={onClose}
      width="600px"
      maximizable={false}
    >
      <div className="p-fluid p-formgrid p-grid">
        <div className="p-col-12 p-md-8">
          <CustomDropdown
            label="Tipo de Veículo :"
            optionLabel="name"
            options={tiposVeiculos}
            value={tiposVeiculos.find(t => t.id === form.manufacturer_id) || null}
            onChange={onTipoVeiculoChange}
            filter
            disabled={emEdicao}
          />
        </div>

        <div className="p-col-12 p-md-2">
          <label>Dia</label>
          <input type="number" value={form.day} disabled className="p-inputtext p-component" />
        </div>

        <div className="p-col-12 p-md-2">
          <label>Valor (R$)</label>
          <InputMoeda
            value={form.value}
            onChange={values => setForm(prev => ({ ...prev, value: values.floatValue }))}
            marginTop={0}
            label=""
          />
        </div>
      </div>

      <div className="p-dialog-footer">
        <Btn onClick={() => onSave(form)} disabled={!form.manufacturer_id || !form.value}>
          Salvar
        </Btn>
      </div>
    </CustomModal>
  )
}
